import state from './moduleNewspaperPdfState'
import actions from './moduleNewspaperPdfActions'
import getters from './moduleNewspaperPdfGetters'
import mutations from './moduleNewspaperPdfMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}

